const status = import.meta.env.MODE || "development";

export const localRequest = import.meta.env.VITE_API_URL ||
  (status === "development"
    ? "http://localhost:9441/admission/"
    : "https://app.hsmltuge.name.ng/admission/");

export const appHost = window.location.origin;

export const UploadLink = "https://app.hsmltuge.name.ng/index.php";
